<template>
    <div>
        <nav class="header-nav hidden md:block w-full tac fixed pin-t pin-x z-20 px-4 h-36 md:p-12">
            <div class="mx-auto relative max-w-3xl text-center flex justify-center items-center">
                <div class="md:flex-grow flex flex-row items-center">
                    <logo class="mr-6 logo" :invert="false" url="#" @click.native="$router.push('/')"></logo>
                    <div class="flex flex-col text-left font-heading uppercase font-medium text-sm">
                        <img src="../assets/tagline/white.png" style="max-width: 120px" />
                    </div>
                </div>
                <div class="flex items-center">
                    <router-link tag="button" :to="{ name: 'home' }" class="nav-item  text-white mr-6">
                        <i class="fal fa-home text-3xl"></i>
                    </router-link>

                    <router-link tag="button" :to="{ name: 'notifications' }"
                                 class="nav-item  text-white relative mr-6">
                        <i class="fal fa-bell text-3xl"></i>
                        <span
                            class="h-4 flex -mt-1 -mr-2 absolute pin-t pin-r items-center justify-center bg-red rounded-full text-white text-xs px-1"
                            v-if="notificationsCount" v-text="notificationsCount"></span>
                    </router-link>

                    <router-link tag="button" :to="{ name: 'account' }" class="nav-item  text-white mr-6">
                        <i class="fal fa-cog text-3xl"></i>
                    </router-link>

                    <button class="nav-item  text-white " @click.prevent="$parent.$refs.navigation.toggle()">
                        <i class="fal fa-bars text-3xl"></i>
                    </button>
                </div>

            </div>
        </nav>

    </div>
</template>

<script>
import menu from '@/menu'
import {mapState} from 'vuex'

export default {
    components: {},
    computed: {
        ...mapState(['notifications']),
        notificationsCount() {
            return this.notifications.length
        }

    }
}
</script>

<style>
.header-nav {
    background-image: url('../assets/gradients/1.jpg');
    background-size: cover;
}

.logo {
    max-width: 90px;
}
</style>
